
const getActiveQuestions = (questions, deletedGroupUuid) => {
  return questions.filter(({groupUuids}) => !groupUuids.includes(deletedGroupUuid))
}

export default getActiveQuestions
